import OdemeSonuc from './pages/OdemeSonuc';
import OdemeSonucBildirimi from './components/OdemeSonucBildirimi';
import YasalOnayModal from './components/YasalOnayModal';
import SistemBildirimPopup from './components/SistemBildirimPopup';
import YetsanMessenger from './components/YetsanMessenger';
import ImpersonationBanner from './components/ImpersonationBanner';
import GuncellemeSeridi from './components/GuncellemeSeridi';
import { CIPProvider } from './components/CIPProvider';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { YetkiProvider, useYetki } from './context/YetkiContext';
import { TeklifListesiProvider } from './context/TeklifListesiContext';
import { ProductProvider } from './context/ProductContext';
import { TabProvider } from './context/TabContext';
import TabLayout from './components/TabLayout';
import { Toaster } from 'sonner';
import { GirisIntroKapisi } from './components/kalibre/GirisIntro';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { installVersionAxiosInterceptor, startVersionWatcher } from './utils/appVersion';
import { installAccountStatusInterceptor } from './utils/accountStatusInterceptor';
import { installAktifFirmaInterceptor } from './utils/aktifFirmaInterceptor';
import { useEffect, lazy, Suspense} from 'react';
import Login from './pages/Login';
import Aktivasyon from './pages/Aktivasyon';
import SiparisTakip from './pages/SiparisTakip';
import TamamlananSiparislerim from './pages/TamamlananSiparislerim.js';
import Siparislerim from './pages/Siparislerim.js';
import WMSLogin from './pages/WMSLogin';
import ErrorBoundary from './components/ErrorBoundary';
import IadeForm from './pages/IadeForm';
// import UpdatePopup from './components/UpdatePopup';  // güncelleme auto-popup'ı kapatıldı
import { ActivityTracker } from './components/ActivityTracker';

// 📦 KOD BÖLME — panel sayfaları istendiğinde inen ayrı parçalara ayrıldı.
//
// Hepsi statik import edildiği için webpack tek bir 7,7 MB'lık paket üretiyordu:
// müşteri, 3 alanlık iade formunu doldurmak için Bacteria AI'dan Excel'e, barkod
// okuyucudan grafik kütüphanesine kadar TÜM admin panelini indiriyordu. Mobil
// veride bu bir dakikayı buluyor ve ekran o süre boyunca beyaz kalıyordu.
//
// Public sayfalar (Login, IadeForm, SiparisTakip, Aktivasyon, OdemeSonuc) EAGER
// kaldı — onlar için ikinci bir ağ gidişi olmasın.
//
// Not: TabLayout'taki PAGE_MAP zaten lazy() kullanıyordu; App.js'in aynı modülleri
// statik import etmesi o bölmeyi etkisiz kılıyordu.
const Adreslerim = lazy(() => import('./pages/Adreslerim'));
const AnaSayfa = lazy(() => import('./pages/AnaSayfa'));
const AracSatis = lazy(() => import('./pages/AracSatis'));
const AuditLog = lazy(() => import('./pages/AuditLog'));
const BacteriaHub = lazy(() => import('./pages/BacteriaHub'));
const BarkodYazdir = lazy(() => import('./pages/BarkodYazdir'));
const CIPDashboard = lazy(() => import('./pages/CIPDashboard'));
const CRMActivities = lazy(() => import('./pages/crm/CRMActivities'));
const CRMCommunications = lazy(() => import('./pages/crm/CRMCommunications'));
const CRMCustomers = lazy(() => import('./pages/crm/CRMCustomers'));
const CRMDashboard = lazy(() => import('./pages/crm/CRMDashboard'));
const CRMKazanim = lazy(() => import('./pages/crm/CRMKazanim'));
const CRMLayout = lazy(() => import('./pages/crm/CRMLayout'));
const CRMPipeline = lazy(() => import('./pages/crm/CRMPipeline'));
const CRMReports = lazy(() => import('./pages/crm/CRMReports'));
const CRMRutRaporu = lazy(() => import('./pages/crm/CRMRutRaporu'));
const CRMTasks = lazy(() => import('./pages/crm/CRMTasks'));
const CanliAnalitik = lazy(() => import('./pages/CanliAnalitik'));
const CariHesap = lazy(() => import('./pages/CariHesap'));
const CariHesaplarYeni = lazy(() => import('./pages/CariHesaplarYeni'));
const CikisListesi = lazy(() => import('./pages/CikisListesi'));
const CohortAnalysis = lazy(() => import('./pages/CohortAnalysis'));
const CumaFirsati = lazy(() => import('./pages/CumaFirsati'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const DepoTransfer = lazy(() => import('./pages/DepoTransfer'));
const DestekTalep = lazy(() => import('./pages/DestekTalep'));
const FirmaDashboard = lazy(() => import('./pages/FirmaDashboard'));
const FiyatTalepleri = lazy(() => import('./pages/FiyatTalepleri'));
const FiyatYonetimi = lazy(() => import('./pages/FiyatYonetimi'));
const GirisListesi = lazy(() => import('./pages/GirisListesi'));
const GuvenlikOlaylari = lazy(() => import('./pages/GuvenlikOlaylari'));
const HizliTeklifOlustur = lazy(() => import('./pages/HizliTeklifOlustur'));
const IadeYonetimi = lazy(() => import('./pages/IadeYonetimi'));
const BayiBasvurulari = lazy(() => import('./pages/BayiBasvurulari'));
const IcKullaniciCihazlari = lazy(() => import('./pages/IcKullaniciCihazlari'));
const IskontoOnay = lazy(() => import('./pages/IskontoOnay'));
const IskontoTanimlari = lazy(() => import('./pages/IskontoTanimlari'));
const Ithalat = lazy(() => import('./pages/Ithalat'));
const KampanyaDuyurular = lazy(() => import('./pages/KampanyaDuyurular'));
const Kasa = lazy(() => import('./pages/Kasa'));
const TecDocArama = lazy(() => import('./pages/TecDocArama'));
const KrediKartiProvizyon = lazy(() => import('./pages/KrediKartiProvizyon'));
const KullaniciAktiviteleri = lazy(() => import('./pages/KullaniciAktiviteleri'));
const KullaniciYonetimi = lazy(() => import('./pages/KullaniciYonetimi'));
const MalCikis = lazy(() => import('./pages/MalCikis'));
const MalGiris = lazy(() => import('./pages/MalGiris'));
const MesaiDisiOnaylar = lazy(() => import('./pages/MesaiDisiOnaylar'));
const MobilKomuta = lazy(() => import('./pages/MobilKomuta'));
const MusteriCariHesap = lazy(() => import('./pages/MusteriCariHesap'));
const MusteriCihazlari = lazy(() => import('./pages/MusteriCihazlari'));
const MusteriCihazlarim = lazy(() => import('./pages/MusteriCihazlarim'));
const MusteriDashboard = lazy(() => import('./pages/MusteriDashboard'));
const MusteriGecmisi = lazy(() => import('./pages/MusteriGecmisi'));
const OnSatisYonetim = lazy(() => import('./pages/OnSatisYonetim'));
const OnSiparisFirsatlari = lazy(() => import('./pages/OnSiparisFirsatlari'));
const OnSiparislerim = lazy(() => import('./pages/OnSiparislerim'));
const PanelDashboard = lazy(() => import('./pages/PanelDashboard'));
const PanelMusteriDetay = lazy(() => import('./pages/PanelMusteriDetay'));
const PanelMusterileri = lazy(() => import('./pages/PanelMusterileri'));
const PanelUrunler = lazy(() => import('./pages/PanelUrunler'));
const Planlama = lazy(() => import('./pages/Planlama'));
const PushBildirim = lazy(() => import('./pages/PushBildirim'));
const Raporlar = lazy(() => import('./pages/Raporlar'));
const ResimIhtiyaciListesi = lazy(() => import('./pages/ResimIhtiyaciListesi'));
const Sepetim = lazy(() => import('./pages/Sepetim'));
const YasalMetinler = lazy(() => import('./pages/YasalMetinler'));
const SifreDegistir = lazy(() => import('./pages/SifreDegistir'));
const SiparisIzniTalepleri = lazy(() => import('./pages/SiparisIzniTalepleri'));
const Siparisler = lazy(() => import('./pages/Siparisler'));
const SistemBildirimleri = lazy(() => import('./pages/SistemBildirimleri'));
const SistemYonetimi = lazy(() => import('./pages/SistemYonetimi'));
const StokDurum = lazy(() => import('./pages/StokDurum'));
const StokResync = lazy(() => import('./pages/StokResync'));
const SystemSelect = lazy(() => import('./pages/SystemSelect'));
const TalepRadari = lazy(() => import('./pages/TalepRadari'));
const Taleplerim = lazy(() => import('./pages/Taleplerim'));
const TeklifListesi = lazy(() => import('./pages/TeklifListesi'));
const TeklifYonetimi = lazy(() => import('./pages/TeklifYonetimi'));
const UrunListesi = lazy(() => import('./pages/UrunListesi'));
const UserManagement = lazy(() => import('./pages/UserManagement'));
const UyelikBilgilerim = lazy(() => import('./pages/UyelikBilgilerim'));
const WMSAdressizUrunler = lazy(() => import('./pages/WMSAdressizUrunler'));
const WMSAnaMenu = lazy(() => import('./pages/WMSAnaMenu'));
const WMSAyarlar = lazy(() => import('./pages/WMSAyarlar'));
const WMSBarkodOkuyucu = lazy(() => import('./pages/WMSBarkodOkuyucu'));
const WMSCikisFisiDetay = lazy(() => import('./pages/WMSCikisFisiDetay'));
const WMSCikisFisleri = lazy(() => import('./pages/WMSCikisFisleri'));
const WMSDashboard = lazy(() => import('./pages/WMSDashboard'));
const WMSEnvanterSayim = lazy(() => import('./pages/WMSEnvanterSayim'));
const WMSEtiketTasarim = lazy(() => import('./pages/WMSEtiketTasarim'));
const WMSGirisFisiDetay = lazy(() => import('./pages/WMSGirisFisiDetay'));
const WMSGirisFisleri = lazy(() => import('./pages/WMSGirisFisleri'));
const WMSHizliIslemler = lazy(() => import('./pages/WMSHizliIslemler'));
const WMSIthalatGiris = lazy(() => import('./pages/WMSIthalatGiris'));
const WMSIthalatGirisDetay = lazy(() => import('./pages/WMSIthalatGirisDetay'));
const WMSRafYonetimi = lazy(() => import('./pages/WMSRafYonetimiYeni'));
const WMSSiparisDetay = lazy(() => import('./pages/WMSSiparisDetay'));
const WMSSiparisMonitor = lazy(() => import('./pages/WMSSiparisMonitor'));
const WMSSiparisler = lazy(() => import('./pages/WMSSiparisler'));
const WMSSistemLoglari = lazy(() => import('./pages/WMSSistemLoglari'));
const WMSUrunRaf = lazy(() => import('./pages/WMSUrunRafYeni'));
const YariMamulYonetimi = lazy(() => import('./pages/YariMamulYonetimi'));
// YETSAN MES — ayrı program (Sistem Seç → MES), kendi kabuğu /mes/*
const MesLayout = lazy(() => import('./pages/mes/MesLayout'));
const MesGenelBakis = lazy(() => import('./pages/mes/MesGenelBakis'));
const MesEkran = lazy(() => import('./pages/mes/MesEkran'));
const MesTalepler = lazy(() => import('./pages/mes/MesTalepler'));
const MesPlanlamaMasasi = lazy(() => import('./pages/mes/MesPlanlamaMasasi'));
const MesIstasyon = lazy(() => import('./pages/mes/MesIstasyon'));
const MesBesleme = lazy(() => import('./pages/mes/MesBesleme'));
const MesFluxKazan = lazy(() => import('./pages/mes/MesFluxKazan'));
const MesBrazing = lazy(() => import('./pages/mes/MesBrazing'));
const MesReceteler = lazy(() => import('./pages/mes/MesReceteler'));
const MesSatinalmaIhtiyaci = lazy(() => import('./pages/mes/MesSatinalmaIhtiyaci'));
const MesSatinalmaSiparisleri = lazy(() => import('./pages/mes/MesSatinalmaSiparisleri'));
const MesTedarikciler = lazy(() => import('./pages/mes/MesTedarikciler'));
const MesKullanicilar = lazy(() => import('./pages/mes/MesKullanicilar'));
const MesGkk = lazy(() => import('./pages/mes/MesGkk'));
const MesDepo = lazy(() => import('./pages/mes/MesDepo'));
const MesCrm = lazy(() => import('./pages/mes/MesCrm'));
const MesProsesKontrol = lazy(() => import('./pages/mes/MesProsesKontrol'));
const MesOlcumResimleri = lazy(() => import('./pages/mes/MesOlcumResimleri'));
const YeniSiparis = lazy(() => import('./pages/YeniSiparis'));
const YeniUrun = lazy(() => import('./pages/YeniUrun'));
const YetsanManage = lazy(() => import('./pages/YetsanManage'));
const YoldakiUrunlerim = lazy(() => import('./pages/YoldakiUrunlerim'));
const YoneticiDashboard = lazy(() => import('./pages/YoneticiDashboard'));


// 🔐 URL → sayfa-yetki anahtarı eşlemesi (en uzun prefix önce eşleşir).
// Burada olmayan yollar (detay sayfaları, ödeme dönüşü vb.) yetki kontrolünden muaftır.
const PATH_SAYFA = [
  ['/panel/firma-dashboard', 'anasayfa'],
  ['/panel/anasayfa', 'anasayfa'],
  ['/panel/yeni-urun', 'yeni-urun'],
  ['/panel/resim-ihtiyaci', 'resim-ihtiyaci'],
  ['/panel/urunler', 'urunler'],
  ['/panel/yeni-siparis', 'yeni-siparis'],
  ['/panel/siparislerim', 'siparislerim'],
  ['/panel/siparis-izni-talepleri', 'siparis-izni-talepleri'],
  ['/panel/siparisler', 'siparisler'],
  ['/panel/teklif-listesi', 'teklif-listesi'],
  ['/panel/hizli-teklif-olustur', 'hizli-teklif'],
  ['/panel/teklifler', 'teklifler'],
  ['/panel/taleplerim', 'taleplerim'],
  ['/panel/panel-musterileri', 'musteriler'],
  ['/panel/musteri-cari', 'musteri-cari'],
  ['/panel/cari-hesaplar', 'cari'],
  ['/panel/cari', 'cari'],
  ['/panel/fiyat-talepleri', 'fiyat-talepleri'],
  ['/panel/fiyat-yonetimi', 'fiyat-yonetimi'],
  ['/panel/iskonto-onay', 'iskonto-onay'],
  ['/panel/kredi-karti-provizyon', 'kredi-karti-provizyon'],
  ['/panel/raporlar', 'raporlar'],
  ['/panel/depo-transfer', 'depo-transfer'],
  ['/panel/stok-resync', 'stok-esitle'],
  ['/panel/ithalat', 'ithalat'],
  ['/panel/yoldaki-urunlerim', 'yoldaki-urunlerim'],
  ['/panel/talep-radari', 'talep-radari'],
  ['/panel/planlama', 'planlama'],
  ['/panel/kasa', 'kasa'],
  ['/panel/promosyon-merkezi', 'promosyon-merkezi'],
  ['/panel/bacteria', 'bacteria'],
  ['/panel/kullanici-yonetimi', 'kullanici-yonetimi'],
  ['/panel/sistem-yonetimi', 'sistem-yonetimi'],
  ['/panel/destek-talep', 'destek-talep'],
  ['/panel/sepetim', 'sepetim'],
  ['/panel/cuma-firsati', 'cuma-firsati'],
  ['/panel/adreslerim', 'adreslerim'],
  ['/panel/uyelik', 'uyelik'],
  ['/panel/sifre-degistir', 'sifre-degistir'],
  ['/wms', 'wms'],
  ['/mes', 'mes-uretim'],     // kişi bazlı tik
];

const pathToSayfa = (pathname) => {
  for (const [prefix, sayfa] of PATH_SAYFA) {
    if (pathname === prefix || pathname.startsWith(prefix + '/')) return sayfa;
  }
  return null;
};

const YetkisizSayfa = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-50 p-6">
    <div className="text-center max-w-md bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
      <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center text-2xl">🔒</div>
      <h2 className="text-lg font-bold text-gray-800 mb-2">Bu sayfaya erişim yetkiniz yok</h2>
      <p className="text-sm text-gray-500">
        Bu modüle erişim yetkiniz bulunmuyor. Erişim için lütfen yöneticinizle iletişime geçin.
      </p>
    </div>
  </div>
);

// Yalnız MES'e giren hesap (services/mes_kullanici) ve açabildiği yollar
const yalnizMesMi = (u) => u?.kullanici_tipi === 'mes';
const yalnizMesYolu = (yol) => yol === '/mes' || yol.startsWith('/mes/');

// MES ekranları — hem genel ağaçta hem yalnız-MES ağacında aynı liste
const MES_ALT_ROTALAR = (
  <>
    <Route index element={<MesGenelBakis />} />
    <Route path="planlama/talepler" element={<MesTalepler />} />
    <Route path="planlama/planlar" element={<MesPlanlamaMasasi />} />
    <Route path="planlama/satinalma" element={<MesSatinalmaIhtiyaci />} />
    <Route path="planlama/siparisler" element={<MesSatinalmaSiparisleri />} />
    <Route path="planlama/tedarikciler" element={<MesTedarikciler />} />
    <Route path="hat/besleme" element={<MesBesleme />} />
    <Route path="hat/dokuma" element={<MesIstasyon proses="P2" ad="Dokuma" />} />
    <Route path="hat/flux-kazan" element={<MesFluxKazan />} />
    <Route path="hat/brazing" element={<MesBrazing />} />
    <Route path="ana-veri/recete" element={<MesReceteler />} />
    <Route path="yonetim/kullanicilar" element={<MesKullanicilar />} />
    <Route path="kalite/gkk" element={<MesGkk />} />
    <Route path="kalite/karantina" element={<MesDepo key="karantina" tip="karantina" />} />
    <Route path="kalite/iade" element={<IadeYonetimi mes />} />
    <Route path="kalite/proses-kontrol" element={<MesProsesKontrol />} />
    <Route path="kalite/olcum-resimleri" element={<MesOlcumResimleri />} />
    <Route path="depo/hammadde" element={<MesDepo key="hammadde" tip="hammadde" />} />
    <Route path="depo/super-market" element={<MesDepo key="super_market" tip="super_market" />} />
    <Route path="depo/ara-depo" element={<MesDepo key="ara_depo" tip="ara_depo" />} />
    <Route path="dokuman/crm" element={<MesCrm />} />
    <Route path="*" element={<MesEkran />} />
  </>
);

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const { sayfaGorebilir } = useYetki();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  // 🎯 SADECE-ÖDEME kullanıcısı (kullanici_tipi='kk_odeme'): panel müşterisi DEĞİL — yalnız KENDİ
  //    cari hesabı (ekstre/hareket) + kredi kartıyla ödeme + şifre değiştirme. Başka sayfaya
  //    gitmeye çalışırsa cari hesabına geri döner. Ürün/fiyat/sipariş vb. erişilemez.
  if (user?.kullanici_tipi === 'kk_odeme') {
    const izinli = ['/panel/musteri-cari', '/panel/sifre-degistir', '/panel/odeme-sonuc'];
    const yol = location.pathname;
    if (!izinli.some(p => yol === p || yol.startsWith(p + '/'))) {
      return <Navigate to="/panel/musteri-cari" replace />;
    }
    return children;
  }

  // 🏭 YALNIZ-MES hesabı (kullanici_tipi='mes', MES › Kullanıcılar'dan açılır): panel, WMS, CRM yok — /mes dışındaki
  //    her yol MES'e döner (şifre değiştirme hariç). Asıl kapı sunucuda (AccountStatusMiddleware): bu yalnız ekran.
  if (yalnizMesMi(user) && !yalnizMesYolu(location.pathname)) return <Navigate to="/mes" replace />;

  // 🔐 Sayfa-erişim kontrolü: yetkiler yüklendiyse ve bu sayfa açıkça kapalıysa engelle.
  // Yüklenmediyse (null) engelleme yok → eski davranış / dayanıklılık.
  const sayfa = pathToSayfa(location.pathname);
  if (sayfa) {
    const gorebilir = sayfaGorebilir(sayfa);
    if (gorebilir === false) return <YetkisizSayfa />;
  }

  return children;
};

// Sadece Firma/Admin kullanıcıları için koruma - Müşteriler erişemez
const FirmaProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (yalnizMesMi(user)) return <Navigate to="/mes" replace />;       // yalnız-MES hesabı: WMS / panel yok

  // Müşteri rolündeki kullanıcılar bu sayfaya erişemez (client veya musteri)
  const isMusteri = user?.role === 'musteri' || user?.role === 'client';
  if (isMusteri) {
    return <Navigate to="/panel/anasayfa" replace />;
  }

  return children;
};

const AppContent = () => {
  const { isAuthenticated, user, loading } = useAuth();
  const userRole = user?.role || '';

  // Token doğrulanırken loading spinner göster - URL değişmeden bekle
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-900">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-400 text-sm">Oturum doğrulanıyor...</p>
        </div>
      </div>
    );
  }

  // Authenticated değilse - sadece public sayfalar
  if (!isAuthenticated) {
    return (
      <Suspense fallback={<SayfaYukleniyor />}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/wms/giris" element={<WMSLogin />} />
        <Route path="/aktivasyon/:token" element={<Aktivasyon />} />
        <Route path="/takip/:token" element={<SiparisTakip />} />
        <Route path="/iade/:token" element={<IadeForm />} />
        <Route path="/odeme-sonuc" element={<OdemeSonuc />} />
        <Route path="/panel/odeme-sonuc" element={<OdemeSonuc />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      </Suspense>
    );
  }

  // 🏭 Yalnız MES'e giren hesap: ayrı, dar ağaç. Sekme sistemi (TabLayout) panel sayfalarını rota korumasının
  //    DIŞINDA çizdiği için bu hesap genel ağaca hiç sokulmaz — /mes dışındaki her adres MES'e döner.
  if (yalnizMesMi(user)) {
    return (
      <Suspense fallback={<SayfaYukleniyor />}>
        <Routes>
          <Route path="/mes" element={<MesLayout />}>
            {MES_ALT_ROTALAR}
          </Route>
          <Route path="*" element={<Navigate to="/mes" replace />} />
        </Routes>
      </Suspense>
    );
  }

  // Authenticated kullanıcı - tüm route'lara erişim
  return (
    <>
      {/* Güncelleme popup'ı kapatıldı — her açılışta (sürüm başına 3×) çıkıyordu, rahatsız ediciydi.
          Sürüm bilgisi/notlar sidebar'da erişilebilir; auto-popup devre dışı. */}
      {/* <UpdatePopup userRole={userRole} /> */}
      {/* <SistemBildirimPopup userRole={userRole} /> */}
      <YetsanMessenger />
      <ImpersonationBanner />
      
      <TabLayout>
      <Suspense fallback={<SayfaYukleniyor />}>
      <Routes>
        {/* Root ve login sayfaları - sistem seçimine yönlendir */}
        <Route path="/" element={<Navigate to="/sistem-sec" replace />} />
        <Route path="/login" element={<Navigate to="/sistem-sec" replace />} />
        {/* Public sipariş takip — giriş yapmış kullanıcı da linke tıklayabilir */}
        <Route path="/takip/:token" element={<SiparisTakip />} />
        <Route path="/iade/:token" element={<IadeForm />} />
        <Route path="/sistem-sec" element={<ProtectedRoute><SystemSelect /></ProtectedRoute>} />
        <Route path="/manage" element={<ProtectedRoute><YetsanManage /></ProtectedRoute>} />
        
        {/* CRM Routes - Panel müşterileri erişemez */}
        <Route path="/crm" element={<FirmaProtectedRoute><CRMLayout /></FirmaProtectedRoute>}>
          <Route index element={<Navigate to="/crm/dashboard" replace />} />
          <Route path="dashboard" element={<CRMDashboard />} />
          <Route path="customers" element={<CRMCustomers />} />
          <Route path="activities" element={<CRMActivities />} />
          <Route path="tasks" element={<CRMTasks />} />
          <Route path="pipeline" element={<CRMPipeline />} />
          <Route path="communications" element={<CRMCommunications />} />
          <Route path="rut" element={<CRMRutRaporu />} />
          <Route path="kazanim" element={<CRMKazanim />} />
          <Route path="reports" element={<CRMReports />} />
        </Route>
        <Route path="/panel/yeni-urun" element={<ProtectedRoute><YeniUrun /></ProtectedRoute>} />
        <Route path="/panel/promosyon-merkezi" element={<ProtectedRoute><KampanyaDuyurular /></ProtectedRoute>} />
        <Route path="/panel/odeme-sonuc" element={<OdemeSonuc />} />
        <Route path="/panel/urunler" element={<ProtectedRoute><PanelUrunler /></ProtectedRoute>} />
        <Route path="/panel/resim-ihtiyaci" element={<ProtectedRoute><ResimIhtiyaciListesi /></ProtectedRoute>} />
        <Route path="/panel" element={<Navigate to="/panel/anasayfa" replace />} />
        <Route path="/panel/dashboard" element={<Navigate to="/panel/anasayfa" replace />} />
        <Route path="/panel/siparisler" element={<ProtectedRoute><Siparisler /></ProtectedRoute>} />
        <Route path="/panel/siparis-izni-talepleri" element={<FirmaProtectedRoute><SiparisIzniTalepleri /></FirmaProtectedRoute>} />
        <Route path="/panel/yeni-siparis" element={<ProtectedRoute><YeniSiparis /></ProtectedRoute>} />
        <Route path="/panel/cari" element={<ProtectedRoute><CariHesap /></ProtectedRoute>} />
        <Route path="/panel/cari-hesaplar" element={<ProtectedRoute><CariHesaplarYeni /></ProtectedRoute>} />
        <Route path="/panel/bacteria" element={<ProtectedRoute><BacteriaHub /></ProtectedRoute>} />
        <Route path="/panel/iade" element={<ProtectedRoute><IadeYonetimi /></ProtectedRoute>} />
        <Route path="/panel/bayi-basvurulari" element={<ProtectedRoute><BayiBasvurulari /></ProtectedRoute>} />
        <Route path="/panel/arac-satis" element={<FirmaProtectedRoute><AracSatis /></FirmaProtectedRoute>} />
        <Route path="/panel/destek-talep" element={<FirmaProtectedRoute><DestekTalep /></FirmaProtectedRoute>} />
        <Route path="/panel/musteri-cari" element={<ProtectedRoute><MusteriCariHesap /></ProtectedRoute>} />
        <Route path="/panel/uyelik" element={<ProtectedRoute><UyelikBilgilerim /></ProtectedRoute>} />
        <Route path="/panel/adreslerim" element={<ProtectedRoute><Adreslerim /></ProtectedRoute>} />
        <Route path="/panel/sepetim" element={<ProtectedRoute><Sepetim /></ProtectedRoute>} />
        <Route path="/panel/yasal-metinler" element={<ProtectedRoute><YasalMetinler /></ProtectedRoute>} />
        <Route path="/panel/cuma-firsati" element={<ProtectedRoute><CumaFirsati /></ProtectedRoute>} />
        <Route path="/panel/sifre-degistir" element={<ProtectedRoute><SifreDegistir /></ProtectedRoute>} />
        <Route path="/sifre-degistir" element={<ProtectedRoute><SifreDegistir /></ProtectedRoute>} />
        <Route path="/panel/siparislerim" element={<ProtectedRoute><ErrorBoundary baslik="Siparişlerim yüklenemedi"><Siparislerim /></ErrorBoundary></ProtectedRoute>} />
        <Route path="/panel/siparisler/:tip/:durum" element={<ProtectedRoute><Siparisler /></ProtectedRoute>} />
        <Route path="/panel/anasayfa" element={<ProtectedRoute><AnaSayfa /></ProtectedRoute>} />
        <Route path="/panel/firma-dashboard" element={<ProtectedRoute><FirmaDashboard /></ProtectedRoute>} />
        <Route path="/panel/musteriler" element={<ProtectedRoute><MusteriDashboard /></ProtectedRoute>} />
        <Route path="/panel/panel-musterileri" element={<ProtectedRoute><PanelMusterileri /></ProtectedRoute>} />
        <Route path="/panel/iskonto-tanimlari" element={<ProtectedRoute><IskontoTanimlari /></ProtectedRoute>} />
        <Route path="/panel/iskonto-onay" element={<ProtectedRoute><IskontoOnay /></ProtectedRoute>} />
        <Route path="/panel/musteri-detay/:id" element={<ProtectedRoute><PanelMusteriDetay /></ProtectedRoute>} />
        <Route path="/panel/musteri/:musteriId/cihazlar" element={<ProtectedRoute><MusteriCihazlari /></ProtectedRoute>} />
        <Route path="/admin/musteri/:musteriId/cihazlar" element={<ProtectedRoute><MusteriCihazlari /></ProtectedRoute>} />
        <Route path="/admin/ic-kullanicilar" element={<ProtectedRoute><IcKullaniciCihazlari /></ProtectedRoute>} />
        <Route path="/panel/cihazlarim" element={<ProtectedRoute><MusteriCihazlarim /></ProtectedRoute>}
          data-testid="cihazlarim-route" />
        <Route path="/panel/guvenlik-olaylari" element={<ProtectedRoute><GuvenlikOlaylari /></ProtectedRoute>} />
        <Route path="/panel/mobil-komuta" element={<FirmaProtectedRoute><MobilKomuta /></FirmaProtectedRoute>} />
        <Route path="/panel/audit-log" element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
        <Route path="/admin/mesai-disi" element={<ProtectedRoute><MesaiDisiOnaylar /></ProtectedRoute>} />
        <Route path="/panel/ithalat" element={<ProtectedRoute><Ithalat /></ProtectedRoute>} />
        <Route path="/panel/depo-transfer" element={<ProtectedRoute><DepoTransfer /></ProtectedRoute>} />
        <Route path="/panel/yoldaki-urunlerim" element={<ProtectedRoute><YoldakiUrunlerim /></ProtectedRoute>} />
        <Route path="/panel/on-siparis-firsatlari" element={<ProtectedRoute><OnSiparisFirsatlari /></ProtectedRoute>} />
        <Route path="/panel/on-satis-yonetim" element={<FirmaProtectedRoute><OnSatisYonetim /></FirmaProtectedRoute>} />
        <Route path="/panel/on-siparislerim" element={<ProtectedRoute><OnSiparislerim /></ProtectedRoute>} />
        <Route path="/panel/teklifler" element={<ProtectedRoute><TeklifYonetimi /></ProtectedRoute>} />
        <Route path="/panel/teklif-listesi" element={<ProtectedRoute><TeklifListesi /></ProtectedRoute>} />
        <Route path="/panel/hizli-teklif-olustur" element={<ProtectedRoute><HizliTeklifOlustur /></ProtectedRoute>} />
        <Route path="/aktivasyon/:token" element={<Aktivasyon />} />

        {/* WMS Routes - Müşteriler erişemez */}
        <Route path="/wms/giris" element={<WMSLogin />} />
        <Route path="/wms/ana-menu" element={<FirmaProtectedRoute><WMSAnaMenu /></FirmaProtectedRoute>} />
        <Route path="/wms/dashboard" element={<FirmaProtectedRoute><WMSDashboard /></FirmaProtectedRoute>} />
        <Route path="/wms/siparisler" element={<FirmaProtectedRoute><WMSSiparisler /></FirmaProtectedRoute>} />
        <Route path="/wms/siparis/:siparis_id" element={<FirmaProtectedRoute><WMSSiparisDetay /></FirmaProtectedRoute>} />
        <Route path="/wms/cikis-fisi/:fis_id" element={<FirmaProtectedRoute><WMSCikisFisiDetay /></FirmaProtectedRoute>} />
        <Route path="/wms/siparis-monitor" element={<FirmaProtectedRoute><ErrorBoundary baslik="Takip Monitörü yüklenemedi"><WMSSiparisMonitor /></ErrorBoundary></FirmaProtectedRoute>} />
        <Route path="/wms/barkod-okuyucu" element={<FirmaProtectedRoute><WMSBarkodOkuyucu /></FirmaProtectedRoute>} />
        <Route path="/wms/raf-yonetimi" element={<FirmaProtectedRoute><WMSRafYonetimi /></FirmaProtectedRoute>} />
        <Route path="/wms/urun-raf" element={<FirmaProtectedRoute><WMSUrunRaf /></FirmaProtectedRoute>} />
        <Route path="/wms/giris-fisleri" element={<FirmaProtectedRoute><WMSGirisFisleri /></FirmaProtectedRoute>} />
        <Route path="/wms/giris-fisi/:fis_id" element={<FirmaProtectedRoute><WMSGirisFisiDetay /></FirmaProtectedRoute>} />
        <Route path="/wms/ithalat-giris" element={<FirmaProtectedRoute><WMSIthalatGiris /></FirmaProtectedRoute>} />
        <Route path="/wms/ithalat-giris/:id" element={<FirmaProtectedRoute><WMSIthalatGirisDetay /></FirmaProtectedRoute>} />
        <Route path="/wms/cikis-fisleri" element={<FirmaProtectedRoute><WMSCikisFisleri /></FirmaProtectedRoute>} />
        <Route path="/wms/envanter-sayim" element={<FirmaProtectedRoute><WMSEnvanterSayim /></FirmaProtectedRoute>} />
        <Route path="/wms/etiket-tasarim" element={<FirmaProtectedRoute><WMSEtiketTasarim /></FirmaProtectedRoute>} />
        <Route path="/wms/hizli-islemler" element={<FirmaProtectedRoute><WMSHizliIslemler /></FirmaProtectedRoute>} />
        <Route path="/wms/ayarlar" element={<FirmaProtectedRoute><WMSAyarlar /></FirmaProtectedRoute>} />
        <Route path="/wms/sistem-loglari" element={<FirmaProtectedRoute><WMSSistemLoglari /></FirmaProtectedRoute>} />
        <Route path="/user-management" element={<FirmaProtectedRoute><UserManagement /></FirmaProtectedRoute>} />
        <Route path="/panel/raporlar" element={<FirmaProtectedRoute><Raporlar /></FirmaProtectedRoute>} />
        <Route path="/panel/talep-radari" element={<FirmaProtectedRoute><TalepRadari /></FirmaProtectedRoute>} />
        <Route path="/panel/planlama" element={<FirmaProtectedRoute><Planlama /></FirmaProtectedRoute>} />
        <Route path="/panel/kasa" element={<FirmaProtectedRoute><Kasa /></FirmaProtectedRoute>} />
        <Route path="/panel/tecdoc" element={<FirmaProtectedRoute><TecDocArama /></FirmaProtectedRoute>} />
        <Route path="/panel/fiyat-talepleri" element={<FirmaProtectedRoute><FiyatTalepleri /></FirmaProtectedRoute>} />
        <Route path="/panel/taleplerim" element={<ProtectedRoute><Taleplerim /></ProtectedRoute>} />
        <Route path="/panel/kullanici-yonetimi" element={<ProtectedRoute><KullaniciYonetimi /></ProtectedRoute>} />
        <Route path="/panel/kredi-karti-provizyon" element={<FirmaProtectedRoute><KrediKartiProvizyon /></FirmaProtectedRoute>} />
        <Route path="/panel/yari-mamul" element={<FirmaProtectedRoute><YariMamulYonetimi /></FirmaProtectedRoute>} />
        <Route path="/panel/mes" element={<Navigate to="/mes" replace />} />
        <Route path="/mes" element={<ProtectedRoute><MesLayout /></ProtectedRoute>}>
          {MES_ALT_ROTALAR}
        </Route>
        <Route path="/panel/fiyat-yonetimi" element={<ProtectedRoute><FiyatYonetimi /></ProtectedRoute>} />
        <Route path="/panel/sistem-yonetimi" element={<ProtectedRoute><SistemYonetimi /></ProtectedRoute>} />
        <Route path="/panel/stok-resync" element={<ProtectedRoute><StokResync /></ProtectedRoute>} />
        <Route path="/wms/adressiz-urunler" element={<ProtectedRoute><WMSAdressizUrunler /></ProtectedRoute>} />
        <Route path="/yonetici-dashboard" element={<ProtectedRoute><YoneticiDashboard /></ProtectedRoute>} />
        <Route path="/panel/sistem-bildirimleri" element={<ProtectedRoute><SistemBildirimleri /></ProtectedRoute>} />
        <Route path="/panel/push-bildirim" element={<FirmaProtectedRoute><PushBildirim /></FirmaProtectedRoute>} />
        <Route path="/panel/kullanici-aktiviteleri" element={<FirmaProtectedRoute><KullaniciAktiviteleri /></FirmaProtectedRoute>} />
        <Route path="/panel/canli-analitik" element={<ProtectedRoute><CanliAnalitik /></ProtectedRoute>} />
        <Route path="/panel/cip" element={<FirmaProtectedRoute><CIPDashboard /></FirmaProtectedRoute>} />
        <Route path="/panel/customer-intelligence" element={<ProtectedRoute><CIPDashboard /></ProtectedRoute>} />
        <Route path="/panel/musteri-gecmisi" element={<FirmaProtectedRoute><MusteriGecmisi /></FirmaProtectedRoute>} />
        <Route path="/panel/cohort-analysis" element={<FirmaProtectedRoute><CohortAnalysis /></FirmaProtectedRoute>} />
      </Routes>
      </Suspense>
      </TabLayout>
    </>
  );
};

/** Lazy sayfa inerken gösterilen ara ekran — boş beyaz alan bırakma. */
function SayfaYukleniyor() {
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', gap: 10, color: '#94a3b8', fontSize: 13 }}>
      <span style={{ width: 16, height: 16, border: '2px solid #e2e8f0',
                     borderTopColor: '#D92E1E', borderRadius: '50%',
                     display: 'inline-block', animation: 'spin 0.8s linear infinite' }} />
      Yükleniyor…
    </div>
  );
}

function App() {
  useEffect(() => {
    // Versiyon mismatch tespit altyapısı:
    // - Axios interceptor → her response'da X-App-Version header'ı kontrolü
    // - Visibility/focus/timer fallback ile periyodik check
    installVersionAxiosInterceptor();
    startVersionWatcher();
    // 🆕 Account status: pasif user / revoke edilmiş session → otomatik logout
    installAccountStatusInterceptor();
    // 🏢 Vekaleten yönetim: seçili "aktif firma" → her isteğe X-Aktif-Firma header'ı
    installAktifFirmaInterceptor();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <YetkiProvider>
          <TabProvider>
          <CIPProvider>
            <ProductProvider>
              <TeklifListesiProvider>
                {/* Güncelleme şeridi — Router içinde olmalı (useLocation ile
                    sayfa değişimini dinleyip güvenli anda kendisi uyguluyor) */}
                <GuncellemeSeridi />
                {/* 💳 KK ödeme sonucu — üstten inen kart, "Gördüm" denene kadar kalır */}
                <OdemeSonucBildirimi />
                {/* 📜 Müşteri KVKK aydınlatma + açık rıza onayı — her metin için bir kez */}
                <YasalOnayModal />
                <AppContent />
                {/* Girişten sonra bir kez: Yetsan logosu lazerle kazınır, sayfa ortadan ikiye açılır */}
                <GirisIntroKapisi />
                {/* ⚠️ SONNER TOASTER — bu satır YOKTU.
                    Proje standardı `sonner` (CLAUDE.md) ve onlarca ekran
                    toast.success/error çağırıyordu ama <Toaster /> hiçbir yerde
                    mount edilmediği için HİÇBİRİ görünmüyordu: işlem başarılı da
                    olsa hata da verse ekranda hiçbir şey olmuyordu (kullanıcı
                    bildirimi: "tıklıyorum hiçbir şey olmuyor").
                    z-index modal'ların üstünde (en yüksek kullanılan z-[99999]). */}
                <Toaster position="top-right" richColors closeButton
                  toastOptions={{ style: { zIndex: 100000 } }}
                  style={{ zIndex: 100000 }} />
                <ToastContainer
                  position="top-right"
                  autoClose={3000}
                  hideProgressBar={false}
                  newestOnTop
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </TeklifListesiProvider>
            </ProductProvider>
          </CIPProvider>
          </TabProvider>
          </YetkiProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
